import { RequestMethodsEnum as s } from "@systemeio/util";
import { useFetch as f } from "../../../utils/http-client.mjs";
const n = () => {
  const { fetcher: e, isFetching: r } = f({
    method: s.post
  });
  return { buyOffer: (t, o) => e("/api/purchase-service/buy-offer", t, {
    headers: {
      "accept-language": o
    }
  }), isFetching: r };
};
export {
  n as useBuyOffer
};
